import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import { useCurrentCompanyId } from "hooks/auth";
import { showToast } from "utils/helpers";
import type { UserListItem } from "../../../types/userInvite";

interface AdminResetUser2faError {
  code?: string;
  message: string;
}

const adminResetUser2fa = async (userId: number): Promise<UserListItem> => {
  const response = await apiV1.post<{ data: UserListItem }>(`users/${userId}/reset-2fa`);
  return response.data.data;
};

export const useAdminResetUser2faMutation = () => {
  const queryClient = useQueryClient();
  const companyId = useCurrentCompanyId();

  return useMutation<UserListItem, AdminResetUser2faError, number>({
    mutationFn: (userId) => adminResetUser2fa(userId),
    retry: false,
    onSuccess: (_data, userId) => {
      queryClient.invalidateQueries({ queryKey: ["user", userId] });
      queryClient.invalidateQueries({ queryKey: ["users", companyId] });
      showToast("User's two-factor authentication has been reset", "Success", true);
    },
    onError: (error) => {
      showToast(
        error?.message || "Failed to reset the user's two-factor authentication. Please try again.",
        "Error",
      );
    },
  });
};
